window.currentCustomerPbProducts = [];

document.addEventListener("turbolinks:load", function () {
  console.log("[PB] turbolinks:load START");

  const form = document.querySelector("form[data-pb-products-url]");
  const customerSelect = document.getElementById("commission_customer_id");

  console.log("[PB] form trovato?", !!form);
  console.log("[PB] customerSelect trovato?", !!customerSelect);

  if (!form || !customerSelect) return;

  if (form.dataset.pbCommissionInit === "1") {
    console.log("[PB] init già eseguita, esco");
    return;
  }

  form.dataset.pbCommissionInit = "1";
  console.log("[PB] init marcata come eseguita");

  let observer = null;

  function csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.getAttribute("content") : "";
  }

  function bootstrapModalInstance(element) {
    if (!element) return null;

    if (window.bootstrap && window.bootstrap.Modal) {
      return window.bootstrap.Modal.getOrCreateInstance(element);
    }

    return {
      show: function () {
        console.log("[PB] modal fallback show");
        element.classList.add("show");
        element.style.display = "block";
        element.removeAttribute("aria-hidden");
        document.body.classList.add("modal-open");

        let backdrop = document.createElement("div");
        backdrop.className = "modal-backdrop fade show js-modal-backdrop";
        document.body.appendChild(backdrop);
      },
      hide: function () {
        console.log("[PB] modal fallback hide");
        element.classList.remove("show");
        element.style.display = "none";
        element.setAttribute("aria-hidden", "true");
        document.body.classList.remove("modal-open");

        document.querySelectorAll(".js-modal-backdrop").forEach(function (el) {
          el.remove();
        });
      }
    };
  }

  function parseNumber(value) {
    if (value === null || value === undefined || value === "") return 0;
    const normalized = String(value).replace(",", ".");
    const parsed = parseFloat(normalized);
    return Number.isNaN(parsed) ? 0 : parsed;
  }

  function formatHours(value) {
    return parseNumber(value).toFixed(2);
  }

  function getProductById(productId) {
    return (window.currentCustomerPbProducts || []).find(function (p) {
      return String(p.id) === String(productId);
    });
  }

  function extractMachineHoursFromProduct(product) {
    if (!product) return [];

    const candidates = [
      product.machine_hours,
      product.pb_product_expected_hours,
      product.product_expected_hours,
      product.expected_hours_rows
    ];

    const rows = candidates.find(function (arr) {
      return Array.isArray(arr);
    });

    return Array.isArray(rows) ? rows : [];
  }

  function rowIsDestroyed(row) {
    const destroyField = row.querySelector('input[name*="[_destroy]"]');
    return destroyField && String(destroyField.value) === "1";
  }

  function getRowQuantity(row) {
    if (!row) return 1;

    const field = row.querySelector('input[name*="[number_of_piece]"]');
    if (!field) return 1;

    const qty = parseNumber(field.value);
    return qty > 0 ? qty : 1;
  }

  function isAttrezzaggio(machineHourRow) {
    const machineName = String(machineHourRow.machine_name || "").trim().toLowerCase();
    return machineName === "attrezzaggio";
  }

  function updateMachineHoursSummary(machineMainTotal, machineAltTotal, operatorMainTotal, operatorAltTotal) {
    const machineMainEl = document.getElementById("commission_total_main_machine_hours");
    const machineAltEl = document.getElementById("commission_total_alternative_machine_hours");
    const operatorMainEl = document.getElementById("commission_total_operator_main_machine_hours");
    const operatorAltEl = document.getElementById("commission_total_operator_alternative_machine_hours");

    if (machineMainEl) machineMainEl.textContent = formatHours(machineMainTotal);
    if (machineAltEl) machineAltEl.textContent = formatHours(machineAltTotal);
    if (operatorMainEl) operatorMainEl.textContent = formatHours(operatorMainTotal);
    if (operatorAltEl) operatorAltEl.textContent = formatHours(operatorAltTotal);
  }

  function recalculateCommissionMachineHours() {
    const rows = document.querySelectorAll("[data-commission-detail-row]");
    console.log("[PB] recalculateCommissionMachineHours rows:", rows.length);

    let totalMachineMain = 0;
    let totalMachineAlt = 0;
    let totalOperatorMain = 0;
    let totalOperatorAlt = 0;

    rows.forEach(function (row) {
      if (rowIsDestroyed(row)) return;

      const pbProductIdField = row.querySelector('input[name*="[pb_product_id]"]');
      if (!pbProductIdField || !pbProductIdField.value) return;

      const product = getProductById(pbProductIdField.value);
      if (!product) return;

      const quantity = getRowQuantity(row);
      const machineHoursRows = extractMachineHoursFromProduct(product);

      let productMachineMain = 0;
      let productMachineAlt = 0;
      let productOperatorMain = 0;
      let productOperatorAlt = 0;
      let hasAlternativeNonAttrezzaggio = false;

      machineHoursRows.forEach(function (mh) {
        const expectedHours = parseNumber(mh.expected_hours) * quantity;
        const priority = String(mh.priority);
        const attrezzaggio = isAttrezzaggio(mh);

        if (priority === "0") {
          if (!attrezzaggio) {
            productMachineMain += expectedHours;
          }
          productOperatorMain += expectedHours;
        } else if (priority === "1") {
          if (!attrezzaggio) {
            productMachineAlt += expectedHours;
            hasAlternativeNonAttrezzaggio = true;
          }
          productOperatorAlt += expectedHours;
        }
      });

      if (!hasAlternativeNonAttrezzaggio) {
        productMachineAlt += productMachineMain;
        productOperatorAlt += productOperatorMain;
      }

      totalMachineMain += productMachineMain;
      totalMachineAlt += productMachineAlt;
      totalOperatorMain += productOperatorMain;
      totalOperatorAlt += productOperatorAlt;
    });

    console.log("[PB] totals", {
      totalMachineMain,
      totalMachineAlt,
      totalOperatorMain,
      totalOperatorAlt
    });

    updateMachineHoursSummary(
      totalMachineMain,
      totalMachineAlt,
      totalOperatorMain,
      totalOperatorAlt
    );
  }

  function loadCustomerProducts(customerId) {
    const baseUrl = form.dataset.pbProductsUrl;
    console.log("[PB] loadCustomerProducts customerId:", customerId, "baseUrl:", baseUrl);

    if (!customerId) {
      window.currentCustomerPbProducts = [];
      updateMachineHoursSummary(0, 0, 0, 0);
      console.log("[PB] nessun customer, cache prodotti svuotata");
      return;
    }

    fetch(`${baseUrl}?customer_id=${customerId}`, {
      headers: { Accept: "application/json" },
      credentials: "same-origin"
    })
      .then(function (response) {
        console.log("[PB] loadCustomerProducts response.ok:", response.ok);
        if (!response.ok) throw new Error("Errore nel caricamento prodotti");
        return response.json();
      })
      .then(function (data) {
        window.currentCustomerPbProducts = data || [];
        console.log("[PB] prodotti caricati:", window.currentCustomerPbProducts.length);
        refreshAllSerialHints();
        recalculateCommissionMachineHours();
      })
      .catch(function (error) {
        window.currentCustomerPbProducts = [];
        updateMachineHoursSummary(0, 0, 0, 0);
        console.error("[PB] Errore caricamento prodotti:", error);
      });
  }

  function refreshProductSerials(pbProductId, newSerial) {
    const product = (window.currentCustomerPbProducts || []).find(function (p) {
      return String(p.id) === String(pbProductId);
    });

    if (!product) return;

    if (!Array.isArray(product.serial_numbers)) {
      product.serial_numbers = [];
    }

    if (!product.serial_numbers.includes(newSerial)) {
      product.serial_numbers.push(newSerial);
    }
  }

  function addProductToCache(product) {
    if (!product) return;

    const exists = (window.currentCustomerPbProducts || []).some(function (p) {
      return String(p.id) === String(product.id);
    });

    if (!exists) {
      window.currentCustomerPbProducts.push(product);
      console.log("[PB] prodotto aggiunto in cache:", product.id);
    }
  }

  function setFieldValue(field, value, force = false) {
    if (!field) return;
    if (force || !field.value.trim()) {
      field.value = value || "";
    }
  }

  function getSelectedProductFromRow(row) {
    const pbProductIdField = row.querySelector('input[name*="[pb_product_id]"]');
    if (!pbProductIdField || !pbProductIdField.value) return null;
    return getProductById(pbProductIdField.value);
  }

  function productHasSerials(product) {
    return !!(product && Array.isArray(product.serial_numbers) && product.serial_numbers.length > 0);
  }

  function highlightSerialField(row, enabled, serialCount = 0) {
    const serialWrap = row.querySelector(".js-serial-field-wrap");
    const helpText = row.querySelector(".js-serial-help-text");

    if (!serialWrap) return;

    if (enabled) {
      serialWrap.classList.add("pb-serial-highlight");
      if (helpText) {
        const plural = serialCount === 1 ? "seriale disponibile" : "seriali disponibili";
        helpText.textContent = `Seleziona il seriale corretto oppure creane uno nuovo (${serialCount} ${plural})`;
        helpText.style.display = "block";
      }
    } else {
      serialWrap.classList.remove("pb-serial-highlight");
      if (helpText) {
        helpText.textContent = "Seleziona il seriale corretto oppure creane uno nuovo";
        helpText.style.display = "none";
      }
    }
  }

  function updateSerialHintForRow(row, options = {}) {
    const serialField = row.querySelector('input[name*="[serial_number]"]');
    const serialValue = serialField ? String(serialField.value || "").trim() : "";

    if (serialValue.length > 0) {
      highlightSerialField(row, false, 0);
      return;
    }

    const product = getSelectedProductFromRow(row);
    const serialCount = productHasSerials(product) ? product.serial_numbers.length : 0;
    highlightSerialField(row, serialCount > 0, serialCount);
  }

  function refreshAllSerialHints() {
    const rows = document.querySelectorAll("[data-commission-detail-row]");
    console.log("[PB] refreshAllSerialHints rows:", rows.length);

    rows.forEach(function (row) {
      updateSerialHintForRow(row);
    });
  }

  function clearSelectedProduct(row) {
    const pbProductIdField = row.querySelector('input[name*="[pb_product_id]"]');
    const serialField = row.querySelector('input[name*="[serial_number]"]');

    if (pbProductIdField) pbProductIdField.value = "";
    if (serialField) serialField.value = "";

    highlightSerialField(row, false, 0);
  }

  function rowFieldMatchesSelectedProduct(row, searchFieldName) {
    const product = getSelectedProductFromRow(row);
    if (!product) return false;

    const productCodeField = row.querySelector('input[name*="[product_code]"]');
    const descriptionField = row.querySelector('input[name*="[description]"]');
    const commissionNumberField = row.querySelector('input[name*="[product_commission_number]"]');

    const currentProductCode = (productCodeField ? productCodeField.value : "").trim();
    const currentDescription = (descriptionField ? descriptionField.value : "").trim();
    const currentCommissionNumber = (commissionNumberField ? commissionNumberField.value : "").trim();

    if (searchFieldName === "product_code") {
      return currentProductCode === String(product.product_code || "");
    }

    if (searchFieldName === "description") {
      return currentDescription === String(product.description || "");
    }

    if (searchFieldName === "commission_number") {
      return currentCommissionNumber === String(product.commission_number || "");
    }

    return true;
  }

  function fillCommissionDetailRow(row, product, options = {}) {
    console.log("[PB] fillCommissionDetailRow product:", product && product.id);

    const matchedSerialNumber = options.matchedSerialNumber || null;
    const forceField = options.forceField || null;
    const hideSerialHintAfterFill = options.hideSerialHintAfterFill === true;

    const pbProductIdField = row.querySelector('input[name*="[pb_product_id]"]');
    const productCodeField = row.querySelector('input[name*="[product_code]"]');
    const descriptionField = row.querySelector('input[name*="[description]"]');
    const commissionNumberField = row.querySelector('input[name*="[product_commission_number]"]');
    const serialNumberField = row.querySelector('input[name*="[serial_number]"]');
    const drawingNumberField = row.querySelector('input[name*="[drawing_number]"]');
    const singlePriceField = row.querySelector('input[name*="[single_price]"]');

    if (pbProductIdField) {
      pbProductIdField.value = product.id || "";
    }

    setFieldValue(productCodeField, product.product_code, forceField === "product_code");
    setFieldValue(descriptionField, product.description, forceField === "description");
    setFieldValue(commissionNumberField, product.commission_number, forceField === "commission_number");
    setFieldValue(drawingNumberField, product.drawing_number, false);
    const previousUnitPrice = singlePriceField?.value;
    setFieldValue(singlePriceField, product.unit_price, false);
    if (singlePriceField && singlePriceField.value !== previousUnitPrice) {
      singlePriceField.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (matchedSerialNumber) {
      setFieldValue(serialNumberField, matchedSerialNumber, true);
    }

    updateSerialHintForRow(row, { hideWhenSerialSelected: hideSerialHintAfterFill });
    recalculateCommissionMachineHours();
  }

  function buildAutocompleteItem(product, onSelect, matchedField, matchedSerialNumber = null) {
    const item = document.createElement("div");
    item.className = "pb-autocomplete-item";

    const codeHtml =
      matchedField === "product_code"
        ? `<span class="pb-autocomplete-code"><strong>${product.product_code || ""}</strong></span>`
        : `<span class="pb-autocomplete-code">${product.product_code || ""}</span>`;

    const descriptionHtml =
      matchedField === "description"
        ? `<span class="pb-autocomplete-description"><strong>${product.description || ""}</strong></span>`
        : `<span class="pb-autocomplete-description">${product.description || ""}</span>`;

    const commissionHtml =
      product.commission_number
        ? (
            matchedField === "commission_number"
              ? `<span class="pb-autocomplete-meta"> | Commessa: <strong>${product.commission_number}</strong></span>`
              : `<span class="pb-autocomplete-meta"> | Commessa: ${product.commission_number}</span>`
          )
        : "";

    const serialHtml =
      matchedSerialNumber
        ? (
            matchedField === "serial_number"
              ? `<span class="pb-autocomplete-meta"> | Seriale: <strong>${matchedSerialNumber}</strong></span>`
              : `<span class="pb-autocomplete-meta"> | Seriale: ${matchedSerialNumber}</span>`
          )
        : "";

    item.innerHTML = `${codeHtml} ${descriptionHtml}${commissionHtml}${serialHtml}`;

    item.addEventListener("mousedown", function (event) {
      event.preventDefault();
      onSelect();
    });

    return item;
  }

  function buildCreateProductItem(onSelect) {
    const item = document.createElement("div");
    item.className = "pb-autocomplete-item pb-autocomplete-create";
    item.innerHTML = "➕ Crea nuovo prodotto";

    item.addEventListener("mousedown", function (event) {
      event.preventDefault();
      onSelect();
    });

    return item;
  }

  function buildCreateSerialItem(serialValue, onSelect) {
    const item = document.createElement("div");
    item.className = "pb-autocomplete-item pb-autocomplete-create";
    item.innerHTML = `➕ Crea seriale: <strong>${serialValue}</strong>`;

    item.addEventListener("mousedown", function (event) {
      event.preventDefault();
      onSelect();
    });

    return item;
  }

  function closeAutocomplete(container) {
    if (container) {
      container.innerHTML = "";
      container.classList.remove("pb-autocomplete-results-right");
    }
  }

  function adjustAutocompleteDirection(resultsBox) {
    if (!resultsBox) return;

    resultsBox.classList.remove("pb-autocomplete-results-right");

    requestAnimationFrame(function () {
      const rect = resultsBox.getBoundingClientRect();
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

      if (rect.right > viewportWidth) {
        resultsBox.classList.add("pb-autocomplete-results-right");
      }
    });
  }

  function findMatches(term, fieldName, row = null) {
    console.log("[PB] findMatches", { term, fieldName });

    const normalizedTerm = term.toLowerCase();
    const selectedProduct = row ? getSelectedProductFromRow(row) : null;

    let products;

    if (fieldName === "serial_number") {
      if (!selectedProduct) return [];
      products = [selectedProduct];
    } else {
      products = window.currentCustomerPbProducts || [];
    }

    const matches = [];

    products.forEach(function (product) {
      if (fieldName === "product_code") {
        if ((product.product_code || "").toLowerCase().includes(normalizedTerm)) {
          matches.push({
            product: product,
            matchedField: "product_code",
            matchedSerialNumber: null
          });
        }
      }

      if (fieldName === "description") {
        if ((product.description || "").toLowerCase().includes(normalizedTerm)) {
          matches.push({
            product: product,
            matchedField: "description",
            matchedSerialNumber: null
          });
        }
      }

      if (fieldName === "commission_number") {
        if (String(product.commission_number || "").toLowerCase().includes(normalizedTerm)) {
          matches.push({
            product: product,
            matchedField: "commission_number",
            matchedSerialNumber: null
          });
        }
      }

      if (fieldName === "serial_number") {
        (product.serial_numbers || []).forEach(function (serial) {
          if ((serial || "").toLowerCase().includes(normalizedTerm)) {
            matches.push({
              product: product,
              matchedField: "serial_number",
              matchedSerialNumber: serial
            });
          }
        });
      }
    });

    console.log("[PB] findMatches risultati:", matches.length);
    return matches.slice(0, 8);
  }

  function renderAllSerialsForSelectedProduct(row, resultsBox, input) {
    const product = getSelectedProductFromRow(row);
    if (!product) return false;

    const serials = Array.isArray(product.serial_numbers) ? product.serial_numbers : [];
    console.log("[PB] renderAllSerialsForSelectedProduct serials:", serials.length);

    if (!serials.length) return false;

    closeAutocomplete(resultsBox);

    serials.slice(0, 20).forEach(function (serial) {
      const item = buildAutocompleteItem(
        product,
        function () {
          fillCommissionDetailRow(row, product, {
            matchedSerialNumber: serial,
            forceField: "serial_number",
            hideSerialHintAfterFill: true
          });

          input.value = serial || "";
          highlightSerialField(row, false, 0);
          closeAutocomplete(resultsBox);
          recalculateCommissionMachineHours();
        },
        "serial_number",
        serial
      );

      resultsBox.appendChild(item);
    });

    adjustAutocompleteDirection(resultsBox);
    return true;
  }

  function openSerialDropdown(row, input) {
    console.log("[PB] openSerialDropdown");

    const wrap = input.closest(".pb-autocomplete-wrap");
    if (!wrap) return;

    const resultsBox = wrap.querySelector(".pb-autocomplete-results");
    if (!resultsBox) return;

    closeAutocomplete(resultsBox);

    const product = getSelectedProductFromRow(row);
    if (!product) return;

    const serials = Array.isArray(product.serial_numbers) ? product.serial_numbers : [];
    console.log("[PB] serial dropdown count:", serials.length);

    if (!serials.length) return;

    serials.forEach(function (serial) {
      const item = buildAutocompleteItem(
        product,
        function () {
          fillCommissionDetailRow(row, product, {
            matchedSerialNumber: serial,
            forceField: "serial_number",
            hideSerialHintAfterFill: true
          });

          input.value = serial;
          highlightSerialField(row, false, 0);
          closeAutocomplete(resultsBox);
        },
        "serial_number",
        serial
      );

      resultsBox.appendChild(item);
    });

    adjustAutocompleteDirection(resultsBox);
  }

  function createSerialForSelectedProduct(row, serialValue, resultsBox, input) {
    const pbProductIdField = row.querySelector('input[name*="[pb_product_id]"]');
    const pbProductId = pbProductIdField ? pbProductIdField.value : "";

    if (!pbProductId) {
      alert("Prima devi selezionare un prodotto.");
      return;
    }

    console.log("[PB] createSerialForSelectedProduct", { pbProductId, serialValue });

    fetch("/commissions/create_pb_product_serial_number", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken(),
        Accept: "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify({
        pb_product_id: pbProductId,
        serial_number: serialValue
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok || !result.data.success) {
          throw new Error(result.data.error || "Errore nella creazione del seriale");
        }

        refreshProductSerials(pbProductId, result.data.serial_number);

        const product = (window.currentCustomerPbProducts || []).find(function (p) {
          return String(p.id) === String(pbProductId);
        });

        if (product) {
          fillCommissionDetailRow(row, product, {
            matchedSerialNumber: result.data.serial_number,
            forceField: "serial_number",
            hideSerialHintAfterFill: true
          });
        }

        input.value = result.data.serial_number || "";
        updateSerialHintForRow(row, { hideWhenSerialSelected: true });
        closeAutocomplete(resultsBox);
      })
      .catch(function (error) {
        alert(error.message || "Errore nella creazione del seriale");
      });
  }

  function addMachineHourRow(machineId = "", expectedHours = "", priority = "0") {
    console.log("[PB] addMachineHourRow", { machineId, expectedHours, priority });

    const container = document.getElementById("pb_machine_hours_rows");
    const template = document.getElementById("pb_machine_hour_row_template");
    if (!container || !template) return;

    const wrapper = document.createElement("div");
    wrapper.innerHTML = template.innerHTML.trim();
    const row = wrapper.firstElementChild;

    const prioritySelect = row.querySelector(".js-pb-priority");
    const machineSelect = row.querySelector(".js-pb-machine-id");
    const expectedHoursInput = row.querySelector(".js-pb-expected-hours");
    const removeBtn = row.querySelector(".js-pb-remove-machine-hour-row");

    if (prioritySelect) prioritySelect.value = String(priority || "0");
    if (machineSelect) machineSelect.value = machineId || "";
    if (expectedHoursInput) expectedHoursInput.value = expectedHours || "";

    if (removeBtn) {
      removeBtn.addEventListener("click", function () {
        row.remove();
      });
    }

    container.appendChild(row);
  }

  function clearMachineHourRows() {
    const container = document.getElementById("pb_machine_hours_rows");
    if (container) container.innerHTML = "";
  }

  function collectMachineHourRows() {
    const rows = document.querySelectorAll("#pb_machine_hours_rows .pb-machine-hour-row");
    const result = [];

    rows.forEach(function (row) {
      const priority = row.querySelector(".js-pb-priority")?.value;
      const machineId = row.querySelector(".js-pb-machine-id")?.value;
      const machineName = row.querySelector(".js-pb-machine-id option:checked")?.textContent?.trim() || "";
      const expectedHours = row.querySelector(".js-pb-expected-hours")?.value;

      if (machineId && expectedHours) {
        result.push({
          machine_id: machineId,
          machine_name: machineName,
          expected_hours: expectedHours,
          priority: priority
        });
      }
    });

    console.log("[PB] collectMachineHourRows count:", result.length);
    return result;
  }

  function openCreateProductModal(detail) {
    console.log("[PB] openCreateProductModal", detail);

    const modalEl = document.getElementById("pbProductCreateModal");
    if (!modalEl) return;

    const modal = bootstrapModalInstance(modalEl);
    const row = detail.row;
    const searchedField = detail.searchedField;
    const searchedValue = detail.searchedValue || "";

    const rowIndexField = document.getElementById("pb_create_row_index");
    const searchedFieldInput = document.getElementById("pb_create_searched_field");

    const productCodeInput = document.getElementById("pb_create_product_code");
    const descriptionInput = document.getElementById("pb_create_description");
    const commissionNumberInput = document.getElementById("pb_create_commission_number");
    const drawingNumberInput = document.getElementById("pb_create_drawing_number");
    const unitPriceInput = document.getElementById("pb_create_unit_price");
    const serialNumberInput = document.getElementById("pb_create_serial_number");
    const errorBox = document.getElementById("pb_create_error_box");

    row.dataset.pbRowUid = row.dataset.pbRowUid || ("row_" + Date.now() + "_" + Math.floor(Math.random() * 100000));

    rowIndexField.value = row.dataset.pbRowUid;
    searchedFieldInput.value = searchedField;

    const rowProductCode = row.querySelector('input[name*="[product_code]"]')?.value || "";
    const rowDescription = row.querySelector('input[name*="[description]"]')?.value || "";
    const rowCommissionNumber = row.querySelector('input[name*="[product_commission_number]"]')?.value || "";
    const rowDrawingNumber = row.querySelector('input[name*="[drawing_number]"]')?.value || "";
    const rowSinglePrice = row.querySelector('input[name*="[single_price]"]')?.value || "";
    const rowSerialNumber = row.querySelector('input[name*="[serial_number]"]')?.value || "";

    productCodeInput.value = searchedField === "product_code" ? searchedValue : rowProductCode;
    descriptionInput.value = searchedField === "description" ? searchedValue : rowDescription;
    commissionNumberInput.value = searchedField === "commission_number" ? searchedValue : rowCommissionNumber;
    drawingNumberInput.value = rowDrawingNumber;
    unitPriceInput.value = rowSinglePrice;
    serialNumberInput.value = searchedField === "serial_number" ? searchedValue : rowSerialNumber;

    clearMachineHourRows();
    addMachineHourRow("", "", "0");

    errorBox.classList.add("d-none");
    errorBox.innerHTML = "";

    modal.show();
  }

  function submitCreateProductModal() {
    console.log("[PB] submitCreateProductModal");

    const modalEl = document.getElementById("pbProductCreateModal");
    if (!modalEl) return;

    const modal = bootstrapModalInstance(modalEl);

    const rowUid = document.getElementById("pb_create_row_index").value;
    const row = document.querySelector(`[data-pb-row-uid="${rowUid}"]`);
    const errorBox = document.getElementById("pb_create_error_box");

    const customerId = customerSelect.value;
    const productCode = document.getElementById("pb_create_product_code").value.trim();
    const description = document.getElementById("pb_create_description").value.trim();
    const commissionNumber = document.getElementById("pb_create_commission_number").value.trim();
    const drawingNumber = document.getElementById("pb_create_drawing_number").value.trim();
    const unitPrice = document.getElementById("pb_create_unit_price").value.trim();
    const serialNumber = document.getElementById("pb_create_serial_number").value.trim();
    const machineHours = collectMachineHourRows();

    if (!customerId) {
      errorBox.classList.remove("d-none");
      errorBox.innerHTML = "Seleziona prima un cliente nella testata della commessa.";
      return;
    }

    fetch("/commissions/create_pb_product", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken(),
        Accept: "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify({
        customer_id: customerId,
        product_code: productCode,
        description: description,
        commission_number: commissionNumber,
        drawing_number: drawingNumber,
        unit_price: unitPrice,
        serial_number: serialNumber,
        machine_hours: machineHours
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok || !result.data.success) {
          throw new Error(result.data.error || "Errore nella creazione del prodotto");
        }

        const product = result.data.product;
        addProductToCache(product);

        if (row && product) {
          fillCommissionDetailRow(row, product, {
            matchedSerialNumber: serialNumber || null,
            forceField: null,
            hideSerialHintAfterFill: false
          });

          const serialField = row.querySelector('input[name*="[serial_number]"]');
          if (serialField && serialNumber) {
            serialField.value = serialNumber;
          }
        }

        refreshAllSerialHints();
        recalculateCommissionMachineHours();
        modal.hide();
      })
      .catch(function (error) {
        errorBox.classList.remove("d-none");
        errorBox.innerHTML = error.message || "Errore nella creazione del prodotto";
      });
  }

  function initAutocompleteForSelector(selector, searchFieldName) {
    const inputs = document.querySelectorAll(selector);
    console.log("[PB] initAutocompleteForSelector", selector, "inputs:", inputs.length);

    inputs.forEach(function (input) {
      if (input.dataset.pbAutocompleteInitialized === "1") return;
      input.dataset.pbAutocompleteInitialized = "1";

      input.addEventListener("focus", function () {
        console.log("[PB] focus su", searchFieldName);

        const row = this.closest("[data-commission-detail-row]");
        if (!row) return;

        if (searchFieldName === "serial_number") {
          openSerialDropdown(row, this);
        }
      });

      input.addEventListener("click", function () {
        console.log("[PB] click su", searchFieldName);

        const row = this.closest("[data-commission-detail-row]");
        if (!row) return;

        if (searchFieldName === "serial_number") {
          openSerialDropdown(row, this);
        }
      });

      input.addEventListener("input", function () {
        const term = this.value.trim();
        console.log("[PB] input su", searchFieldName, "term:", term);

        const row = this.closest("[data-commission-detail-row]");
        if (!row) return;

        const wrap = this.closest(".pb-autocomplete-wrap");
        if (!wrap) return;

        const resultsBox = wrap.querySelector(".pb-autocomplete-results");
        if (!resultsBox) return;

        closeAutocomplete(resultsBox);

        if (!term.length) {
          if (searchFieldName === "serial_number") {
            const selectedProduct = getSelectedProductFromRow(row);
            if (selectedProduct) {
              renderAllSerialsForSelectedProduct(row, resultsBox, this);
            }
          }

          recalculateCommissionMachineHours();
          return;
        }

        const matches = findMatches(term, searchFieldName, row);

        if (matches.length > 0) {
          matches.forEach(function (match) {
            const item = buildAutocompleteItem(
              match.product,
              function () {
                fillCommissionDetailRow(row, match.product, {
                  matchedSerialNumber: match.matchedSerialNumber,
                  forceField: searchFieldName,
                  hideSerialHintAfterFill: searchFieldName === "serial_number"
                });

                if (searchFieldName === "product_code") {
                  input.value = match.product.product_code || "";
                } else if (searchFieldName === "description") {
                  input.value = match.product.description || "";
                } else if (searchFieldName === "commission_number") {
                  input.value = match.product.commission_number || "";
                } else if (searchFieldName === "serial_number") {
                  input.value = match.matchedSerialNumber || "";
                  highlightSerialField(row, false, 0);
                }

                if (searchFieldName === "serial_number") {
                  updateSerialHintForRow(row, { hideWhenSerialSelected: true });
                } else {
                  updateSerialHintForRow(row, { hideWhenSerialSelected: false });
                }

                closeAutocomplete(resultsBox);
                recalculateCommissionMachineHours();
              },
              match.matchedField,
              match.matchedSerialNumber
            );

            resultsBox.appendChild(item);
          });

          adjustAutocompleteDirection(resultsBox);
        } else {
          if (searchFieldName === "serial_number") {
            const selectedProduct = getSelectedProductFromRow(row);

            if (selectedProduct) {
              const createSerialItem = buildCreateSerialItem(term, function () {
                createSerialForSelectedProduct(row, term, resultsBox, input);
              });

              resultsBox.appendChild(createSerialItem);
              adjustAutocompleteDirection(resultsBox);
              return;
            }
          }

          const createItem = buildCreateProductItem(function () {
            openCreateProductModal({
              row: row,
              searchedField: searchFieldName,
              searchedValue: term
            });
            closeAutocomplete(resultsBox);
          });

          resultsBox.appendChild(createItem);
          adjustAutocompleteDirection(resultsBox);
        }
      });

      input.addEventListener("blur", function () {
        const wrap = this.closest(".pb-autocomplete-wrap");
        if (!wrap) return;

        const resultsBox = wrap.querySelector(".pb-autocomplete-results");
        setTimeout(function () {
          closeAutocomplete(resultsBox);
        }, 200);
      });

      input.addEventListener("change", function () {
        console.log("[PB] change su", searchFieldName);

        const row = this.closest("[data-commission-detail-row]");
        if (!row) {
          recalculateCommissionMachineHours();
          return;
        }

        if (searchFieldName !== "serial_number") {
          const hasSelectedProduct = !!getSelectedProductFromRow(row);

          if (hasSelectedProduct && !rowFieldMatchesSelectedProduct(row, searchFieldName)) {
            clearSelectedProduct(row);
          } else {
            updateSerialHintForRow(row);
          }
        }

        recalculateCommissionMachineHours();
      });
    });
  }

  function initAllAutocompletes() {
    console.log("[PB] initAllAutocompletes");
    initAutocompleteForSelector(".js-pb-product-code", "product_code");
    initAutocompleteForSelector(".js-pb-product-description", "description");
    initAutocompleteForSelector(".js-pb-product-commission-number", "commission_number");
    initAutocompleteForSelector(".js-pb-product-serial-number", "serial_number");
  }

  customerSelect.addEventListener("change", function () {
    console.log("[PB] customerSelect change:", this.value);
    loadCustomerProducts(this.value);
  });

  if (customerSelect.value) {
    console.log("[PB] customerSelect iniziale valorizzato:", customerSelect.value);
    loadCustomerProducts(customerSelect.value);
  } else {
    console.log("[PB] customerSelect iniziale vuoto");
    updateMachineHoursSummary(0, 0, 0, 0);
  }

  initAllAutocompletes();

  const detailsWrapper = document.querySelector("[data-commission-details-wrapper]");
  console.log("[PB] detailsWrapper trovato?", !!detailsWrapper);

  if (detailsWrapper) {
    detailsWrapper.addEventListener("input", function (event) {
      const target = event.target;

      if (
        target.matches('input[name*="[number_of_piece]"]') ||
        target.matches('input[name*="[pb_product_id]"]') ||
        target.matches('input[name*="[product_code]"]') ||
        target.matches('input[name*="[description]"]') ||
        target.matches('input[name*="[product_commission_number]"]') ||
        target.matches('input[name*="[serial_number]"]')
      ) {
        console.log("[PB] detailsWrapper input rilevante");
        recalculateCommissionMachineHours();
      }
    });

    detailsWrapper.addEventListener("change", function () {
      console.log("[PB] detailsWrapper change");
      recalculateCommissionMachineHours();
    });

    detailsWrapper.addEventListener("click", function (event) {
      const removeBtn = event.target.closest("[data-commission-details-remove]");
      if (!removeBtn) return;

      console.log("[PB] click su remove detail row");

      setTimeout(function () {
        recalculateCommissionMachineHours();
      }, 0);
    });

    observer = new MutationObserver(function (mutations) {
      console.log("[PB] MutationObserver trigger mutations:", mutations.length);

      const hasRelevantRowChange = mutations.some(function (mutation) {
        const addedRelevant = Array.from(mutation.addedNodes).some(function (node) {
          return node.nodeType === 1 && (
            (node.matches && node.matches("[data-commission-detail-row]")) ||
            (node.querySelector && node.querySelector("[data-commission-detail-row]"))
          );
        });

        const removedRelevant = Array.from(mutation.removedNodes).some(function (node) {
          return node.nodeType === 1 && (
            (node.matches && node.matches("[data-commission-detail-row]")) ||
            (node.querySelector && node.querySelector("[data-commission-detail-row]"))
          );
        });

        return addedRelevant || removedRelevant;
      });

      console.log("[PB] MutationObserver hasRelevantRowChange:", hasRelevantRowChange);

      if (!hasRelevantRowChange) return;

      initAllAutocompletes();
      refreshAllSerialHints();
      recalculateCommissionMachineHours();
    });

    observer.observe(detailsWrapper, { childList: true });
    console.log("[PB] MutationObserver attivato");
  }

  const createProductSubmit = document.getElementById("pb_create_product_submit");
  if (createProductSubmit && !createProductSubmit.dataset.pbCreateInit) {
    createProductSubmit.dataset.pbCreateInit = "1";
    createProductSubmit.addEventListener("click", submitCreateProductModal);
    console.log("[PB] createProductSubmit init");
  }

  const modalEl = document.getElementById("pbProductCreateModal");

  if (modalEl && !modalEl.dataset.pbCloseInit) {
    modalEl.dataset.pbCloseInit = "1";
    console.log("[PB] modal init");

    modalEl.querySelectorAll('[data-bs-dismiss="modal"], .btn-close').forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        const modal = bootstrapModalInstance(modalEl);
        modal.hide();
      });
    });

    modalEl.addEventListener("click", function (event) {
      if (event.target === modalEl) {
        const modal = bootstrapModalInstance(modalEl);
        modal.hide();
      }
    });
  }

  const addMachineHourBtn = document.getElementById("pb_add_machine_hour_row");
  if (addMachineHourBtn && !addMachineHourBtn.dataset.pbInit) {
    addMachineHourBtn.dataset.pbInit = "1";
    addMachineHourBtn.addEventListener("click", function () {
      console.log("[PB] click addMachineHourBtn");
      addMachineHourRow();
    });
  }

  refreshAllSerialHints();
  recalculateCommissionMachineHours();

  console.log("[PB] turbolinks:load END");

  document.addEventListener("turbolinks:before-cache", function cleanupPbCommission() {
    console.log("[PB] turbolinks:before-cache cleanup");

    if (observer) observer.disconnect();

    if (form) {
      delete form.dataset.pbCommissionInit;
    }

    document.removeEventListener("turbolinks:before-cache", cleanupPbCommission);
  });
});
